var _pattern, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1493,
    viewBox: "0 0 1056 1493",
    width: 1056,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    height: 10,
    patternUnits: "userSpaceOnUse",
    width: 10,
    x: -10,
    y: -10
  }, /*#__PURE__*/React.createElement("image", {
    height: 100,
    transform: "scale(.1)",
    width: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABGdBTUEAALGN5fIAKQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAMc/x7AAABgElEQVR4Ae3TsQ2AMBTEUEAswkrsyFrMQEkHiBFSvcLpv2TZuXnbj2fqMQYWhiSQ30BBsI9QkIJgBjCcFlIQzACG00IKghnAcFpIQTADGE4LKQhmAMNpIQXBDGA4LaQgmAEMp4UUBDOA4bSQgmAGMJwWUhDMAIbTQgqCGcBwWkhBMAMYTgspCGYAw2khBcEMYDgtpCCYAQynhRQEM4DhtJCCYAYwnBZSEMwAhtNCCoIZwHBaSEEwAxhOCykIZgDDaSEFwQxgOC2kIJgBDKeFYEFWjGcY577O4VvpsIVINT6WghQEM4DhtJCCYAYwnBZSEMwAhtNCCoIZwHBaSEEwAxhOCykIZgDDaSEFwQxgOC2kIJgBDKeFFAQzgOG0kIJgBjCcFlIQzACG00IKghnAcFpIQTADGE4LKQhmAMNpIQXBDGA4LaQgmAEMp4UUBDOA4bSQgmAGMJwWUhDMAIbTQgqCGcBwWkhBMAMYTgspCGYAw2khBcEMYDgtpCCYAQznBegSBacC9um0AAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1493v-1493h1056v1493zm981-1418h-906v1343h906z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 972h297v256h-297z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98 98h860v1297h-860z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 106h844v1282h-844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114 114h828v1266h-828z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h10v10h-10z",
    fill: "#2e519f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 5h5v5h-5z",
    fill: "#24417f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertBg);
export default __webpack_public_path__ + "static/media/cert_bg.65d7cc27c35c4ac71a695a832c91f99b.svg";
export { ForwardRef as ReactComponent };